import { Uom } from '../default-flight/default-flight.model';

export interface GlobalSettings {
    id: string;
    name: string;
    logoUrl: string | null;
    uom: Uom;
    language: LanguagesEnum;
    /** Legacy site-level email; retained for API compatibility until user management ships. */
    email?: string;
    tenantId?: string;
    siteId?: string;
    createdDate?: string | null;
    createdBy?: string | null;
    modifiedDate?: string | null;
    modifiedBy?: string | null;
    isDeleted?: boolean;
    orientation?: number;
}

export enum LanguagesEnum {
    English = 0,
    EnglishAustralia = 1,
    Spanish = 2,
    Italian = 3,
    Japanese = 4,
    Chinese = 5,
    Danish = 6,
    French = 7,
    German = 8,
    Portuguese = 9,
    EnglishUS = 10,
    ChineseTraditional = 11,
}

export interface LanguageOption {
    id: LanguagesEnum;
    name: string;
    /**
     * ISO 3166-1 alpha-2 country code used by the `flag-icons` package to
     * render a small flag next to the language label (`<span class="fi fi-<code>"></span>`).
     */
    flagCode: string;
}

/**
 * Fixed dropdown list shown on the Global Settings page. Order matches the
 * product spec; we deliberately do not fetch this from the API.
 */
export const LANGUAGE_OPTIONS: LanguageOption[] = [
    { id: LanguagesEnum.English, name: 'English', flagCode: 'gb' },
    { id: LanguagesEnum.EnglishAustralia, name: 'English (Australia)', flagCode: 'au' },
    { id: LanguagesEnum.EnglishUS, name: 'English (US)', flagCode: 'us' },
    { id: LanguagesEnum.Chinese, name: 'Chinese', flagCode: 'cn' },
    { id: LanguagesEnum.Danish, name: 'Danish', flagCode: 'dk' },
    { id: LanguagesEnum.French, name: 'French', flagCode: 'fr' },
    { id: LanguagesEnum.German, name: 'German', flagCode: 'de' },
    { id: LanguagesEnum.Italian, name: 'Italian', flagCode: 'it' },
    { id: LanguagesEnum.Portuguese, name: 'Portuguese', flagCode: 'pt' },
    { id: LanguagesEnum.Spanish, name: 'Spanish', flagCode: 'es' },
    {
        id: LanguagesEnum.ChineseTraditional,
        name: 'Chinese (Traditional / Taiwan)',
        flagCode: 'tw',
    },
];

export const LOGO_GUIDELINES = {
    width: 200,
    height: 100,
    maxBytes: 1024 * 1024,
    accept: 'image/png,image/svg+xml,image/jpeg',
} as const;
